export type GalleryFileType = 'image' | 'gif' | 'video' | 'pdf' | 'attachment';

export const GALLERY_UPLOAD_LIMITS = {
  maxImageDimensionPx: 1920,
  maxImageBytes: 2 * 1024 * 1024,
  maxGifBytes: 3 * 1024 * 1024,
  maxVideoBytes: 50 * 1024 * 1024,
  maxPdfBytes: 10 * 1024 * 1024,
  minJpegQuality: 0.5,
  initialJpegQuality: 0.85,
  qualityStep: 0.05,
} as const;

export function validateGalleryFileSize(
  file: File,
  fileType: GalleryFileType
): { valid: boolean; message?: string } {
  const sizeMB = file.size / (1024 * 1024);

  switch (fileType) {
    case 'image':
      if (file.size > GALLERY_UPLOAD_LIMITS.maxImageBytes) {
        return {
          valid: false,
          message: `Image size (${sizeMB.toFixed(2)}MB) exceeds ${formatLimitMb(GALLERY_UPLOAD_LIMITS.maxImageBytes)} limit`,
        };
      }
      break;
    case 'gif':
      if (file.size > GALLERY_UPLOAD_LIMITS.maxGifBytes) {
        return {
          valid: false,
          message: `GIF size (${sizeMB.toFixed(2)}MB) exceeds ${formatLimitMb(GALLERY_UPLOAD_LIMITS.maxGifBytes)} limit`,
        };
      }
      break;
    case 'video':
      if (file.size > GALLERY_UPLOAD_LIMITS.maxVideoBytes) {
        return {
          valid: false,
          message: `Video size (${sizeMB.toFixed(2)}MB) exceeds ${formatLimitMb(GALLERY_UPLOAD_LIMITS.maxVideoBytes)} limit`,
        };
      }
      break;
    case 'pdf':
      if (file.size > GALLERY_UPLOAD_LIMITS.maxPdfBytes) {
        return {
          valid: false,
          message: `PDF size (${sizeMB.toFixed(2)}MB) exceeds ${formatLimitMb(GALLERY_UPLOAD_LIMITS.maxPdfBytes)} limit`,
        };
      }
      break;
  }

  return { valid: true };
}

function formatLimitMb(bytes: number): string {
  return `${(bytes / (1024 * 1024)).toFixed(0)}MB`;
}
